import React from 'react';
import styles from './Footer.module.scss';
import cx from 'classnames';
import { QuizInput } from '../../quiz';

interface FooterProps {
  isChallenge?: boolean;
}

const Footer: React.FC<FooterProps> = ({ isChallenge = false }) => {
  const currentYear = new Date().getFullYear();

  if (isChallenge) {
    return (
      <div className={cx(styles.footer, styles.challengeStep)}>
        <div className={styles.inputFooter}>
          <QuizInput />
        </div>
      </div>
    );
  }

  return (
    <footer className={styles.footer}>
      <div>
        <p>© {currentYear} FLEXXI CARE - Alle Rechte vorbehalten</p>
      </div>
    </footer>
  );
};

export default Footer;
